import { render, staticRenderFns } from "./BoxOptions.vue?vue&type=template&id=61a43f2e&scoped=true&"
import script from "./BoxOptions.vue?vue&type=script&lang=js&"
export * from "./BoxOptions.vue?vue&type=script&lang=js&"
import style0 from "./BoxOptions.vue?vue&type=style&index=0&id=61a43f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a43f2e",
  null
  
)

export default component.exports